import type { Block } from 'sanity-typed-queries';

export const simplifyPortableTextSpans = (children: Block['children']) => {
  return children.reduce<Block['children']>((acc, child) => {
    const shouldPush = (
      acc.length === 0
      || !(
        child.marks.length === acc[acc.length - 1].marks.length
        && child.marks.every(mark => acc[acc.length - 1].marks.includes(mark))
      )
    );
    if (shouldPush) {
      acc.push(child);
    } else {
      acc[acc.length - 1].text += child.text;
    }
    return acc;
  }, []);
}